import BreadCrumV2 from "components/individual/breadCrums/BreadCrumV2";
import useQueryParams from "customHooks/useQueryParams";
import useQuote from "customHooks/useQuote";
import React, { createContext } from "react";
import { AddDocument } from "components/Sections/Documents/AddDocument";
import ui from 'structure/ODC/styles.module.scss';
import usePermissions from "customHooks/usePermissions";

/**
 * Context for the quote
 * @type {import("react").Context<import("types/typedef/customHooks/useQuote").ContextI|undefined>}
 */
export const QuoteContext = createContext(undefined);
export const { Provider } = QuoteContext;

export default function Quote() {
  const params = useQueryParams();

  usePermissions('137d70b3-8603-43b8-b8de-8503e490ae18');

  const {
    openModalCreateContact,
    document,
    updateReminderDate,
    updateTc,
    updateCurrency,
    updatePeriocity,
    updateDocumentItemsInfo,
    uens,
    updateProbability,
    customer,
    triggerAddQuote,
    updateExistingContact,
    updateRegularComments,
    updateNotesAndConsiderations,
    pathBreadcrum,
    partidas,
    isPerformingQuery,
    isDocumentFetched,
    updateExpirationDate,
    updateContact,
    setContacts,
    appendContactOnMemory,
    contactsOnMemory,
  } = useQuote({
    idCustomer: +params.idCliente,
  });

  return (
    <Provider
      value={{
        isPerformingQuery,
        openModalCreateContact,
        updateReminderDate,
        document,
        idCustomer: params.idCliente,
        updateTc,
        updateRegularComments,
        appendContactOnMemory,
        updateCurrency,
        updateExpirationDate,
        updatePeriocity,
        updateProbability,
        updateExistingContact,
        partidas,
        isDocumentFetched,
        updateContact,
        triggerAddQuote,
        contactsOnMemory,
        setContacts,
      }}
    >
      <div className={ui.container}>
      <BreadCrumV2 path={pathBreadcrum} />
      <AddDocument
        actionType="Agregar"
        customerId={params.idCliente}
        documentType={1}
      />
      </div>

      {/* <div className="container">
        <header className="my-3 d-flex align-items-center justify-content-between">
          <div>
            <ExchangeInformative>
              <ExchangeInformative.Dof /> |
              <ExchangeInformative.Bank /> |
              <ExchangeInformative.Enterprise /> |
              <span className={styles.informativePipe}>
                <span>Razón social</span>
                <span>{customer?.socialReason}</span>
              </span>
              {document.currency !== null ? (
                <span className={styles.informativePipe}>
                  <span>Moneda</span>
                  <span>{document.currency}</span>
                </span>
              ) : null}
              <ExchangeInformative.Date />
            </ExchangeInformative>
          </div>
          <AddQuote />
        </header>

        <Tabs
          idContainerContent="document"
          idContainerTabs="tab"
          tabButtons={{
            document: {
              text: "Cotización",
              selected: true,
              component: <QuoteTab />,
            },
            documentItems: {
              text: "Partidas",
              selected: false,
              component: (
                <Partidas
                  onChange={updateDocumentItemsInfo}
                  currency={document.currency}
                  calculationMode="pu"
                  typeDocument="cotizacion"
                  tc={document.tc}
                />
              ),
            },
            documentComments: {
              text: "Notas y consideraciones",
              selected: false,
              component: (
                <Tabs
                  idContainerContent="notesAndConsiderations"
                  idContainerTabs="tabNotesAndConsiderations"
                  tabButtons={{
                    comments: {
                      text: "Comentarios",
                      selected: false,
                      component: (
                        <CommentsDocument
                          onChange={updateRegularComments}
                          idTypeDocument={1}
                        />
                      ),
                    },
                    notesconsiderations: {
                      text: "Notas y consideraciones",
                      selected: true,
                      component: isDocumentFetched ? (
                        <NoteConsideration
                          idTypeDocument={1}
                          periocity={document.periocity.message}
                          currency={document.currency}
                          uen={uens}
                          onChange={updateNotesAndConsiderations}
                        />
                      ) : null,
                    },
                  }}
                />
              ),
            },
          }}
        />
      </div> */}
    </Provider>
  );
}
